import React from 'react';

export const DEFAULT_FIELD_STYLES: React.CSSProperties = {
  borderRadius: 8,
};
